/* eslint-disable */
import dayjs from 'dayjs';
import { MONITOREOS_ESPECTACULARES } from 'constants/tipoMonitoreos';
import { INICIO, CIERRE } from 'constants/tipoActas';
import { MONITOREO_EN_PROCESO } from 'constants/estatusMonitoreo';
import { TIPO_ACCESO_WEB } from 'constants/tiposAcceso';
import { FORMAT_BACKEND } from 'constants/dateFormat';
import { getFileDataUri } from 'utils/file';

// const generateImageUri = (base64String) => (base64String ? getFileDataUri(base64String) : null);const generateImageUri = (base64String) => {
const generateImageUri = (base64String) => {
  const base64StringSafe = String(base64String);
  return base64StringSafe ? getFileDataUri(base64StringSafe) : null;
};

const findElementNomBene = (array, searchElement) => 
{
  if (array?.length !== undefined) 
  {
    // console.log('searchElement: ', searchElement);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < array.length; i++) 
    {
      const element = array[i];
      if (element.nombreBeneficiado === undefined || element.nombreBeneficiado === '' || element.nombreBeneficiado === null) 
      {
        // console.log('undefined');
        return null;
      }
      if (element.nombreBeneficiado === searchElement) 
      {
        // console.log('searchElement');
        return i;
      }
    }
  }
  return -1;
};

const findByElement = (array, element, searchElement) => {
  if (array?.length !== undefined) {
    for (let i = 0; i < array.length; i += 1) {
      const objectElement = array[i];
      if (objectElement[element] === undefined) return null;
      if (objectElement[element] === searchElement) {
        return i;
      }
    }
  }
  return -1;
};

const eliminarObjetosDuplicadosPorPropiedad = (
  arr,
  propiedad1,
  propiedad2,
  propiedad3,
  propiedad4
) => {
  const objetoTemporal = {};
  return arr.filter((objeto) => {
    const valores = [
      objeto[propiedad1] ?? "NULL",
      objeto[propiedad2] ?? "NULL",
      objeto[propiedad3] ?? "NULL",
      objeto[propiedad4] ?? "NULL"
    ];

    const clave = JSON.stringify(valores);
    if (!objetoTemporal[clave]) {
      objetoTemporal[clave] = true;
      return true;
    }
    return false;
  });
};

export const newFormatBeneficiados = (
  beneficiados,
  catalogoBeneficiados,
  idProcesoEspecifico,
  beneficiadosOriginales
) => {
  let beneficiadoTemp;

  // console.log('beneficiados: ', beneficiados);
  // console.log('beneficiadosOriginales: ', beneficiadosOriginales);

  const beneficiadosFormateados = beneficiados?.map((beneficiado, index) => 
  {
    if (beneficiado.beneficiado > 0) 
    {
      beneficiadoTemp =
        catalogoBeneficiados?.find((b) => b.idContabilidad === beneficiado.beneficiado) || {};

      if (beneficiadoTemp == undefined || Object.keys(beneficiadoTemp).length === 0) 
      {
        const beneficiadoFormateado = {
          ...beneficiado,
          pkBeneficiado: index + 1
        };
        return beneficiadoFormateado;
      }else{
        const beneficiadoFormateado = {
          ...beneficiadoTemp,
          pkBeneficiado: index + 1
        };
        return beneficiadoFormateado;
      }
    }

    if (beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado !== 0) 
    {
      const beneficiadosTemporales =
        catalogoBeneficiados?.filter(
          (b) =>
            b.idProcesoSIMAC === idProcesoEspecifico &&
            b.idSujetoObligado === beneficiado.idSujetoObligado &&
            b.idTipoAsociacion === beneficiado.idTipoAsociacion
        ) || [];

      beneficiadoTemp = beneficiado.cargo
        ? beneficiadosTemporales?.find((b) => b.cargo === beneficiado.cargo)
        : beneficiadosTemporales[0] || {};

      // console.log('beneficiadoTemp: ', beneficiadoTemp);
      
      if (beneficiadoTemp == undefined || Object.keys(beneficiadoTemp).length === 0) 
      {
        const beneficiadoFormateado = {
          ...beneficiado,
          cargo: beneficiado.cargo,
          pkBeneficiado: index + 1,
        };
        return beneficiadoFormateado;
      }
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    if (beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado === 0) {
      const beneficiadosTemporales =
        catalogoBeneficiados?.filter(
          (b) =>
            b.idProcesoSIMAC === idProcesoEspecifico &&
            b.idTipoAsociacion === beneficiado.idTipoAsociacion
        ) || [];

      beneficiadoTemp = beneficiado.cargo
        ? beneficiadosTemporales?.find((b) => b.cargo === beneficiado.cargo)
        : beneficiadosTemporales[0] || {};

      if (beneficiadoTemp == undefined || Object.keys(beneficiadoTemp).length === 0) {
        const beneficiadoFormateado = {
          ...beneficiado,
          cargo: beneficiado.cargo,
          idSujetoObligado: beneficiado.idSujetoObligado,
          sujetoObligado: beneficiado.sujetoObligado,
          pkBeneficiado: index + 1
        };
        return beneficiadoFormateado;
      }
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        idSujetoObligado: beneficiado.idSujetoObligado,
        sujetoObligado: beneficiado.sujetoObligado,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    const beneficiadoFormateado = {
      ...beneficiado,
      pkBeneficiado: index + 1 // Dato arbitrario solicitado por el backend
    };
    return beneficiadoFormateado;
  });

  // console.log('beneficiadosFormateados: ', beneficiadosFormateados);

  let beneficiadosFormateadosSinDuplicidad;

  if (beneficiados?.length !== 0 && beneficiados[0].beneficiado === undefined) {
    // console.log('entro aqui');
    beneficiadosFormateadosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
      beneficiadosFormateados,
      'nombreBeneficiado',
      'idTipoAsociacion',
      'idContabilidad'
    );
  }

  // console.log('beneficiadosFormateadosSinDuplicidad 1: ', beneficiadosFormateadosSinDuplicidad);

  beneficiadosFormateadosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
    beneficiadosFormateados,
    'nombreBeneficiado',
    'idTipoAsociacion',
    'idSujetoObligado',
    'cargo'
  );

  // console.log('beneficiadosFormateadosSinDuplicidad 2: ', beneficiadosFormateadosSinDuplicidad);

  beneficiadosOriginales?.map((beneficiadoOriginal) => {
    let updatedBeneficiado = {};

    const index = findElementNomBene(
      beneficiadosFormateadosSinDuplicidad,
      beneficiadoOriginal.nombreBeneficiado
    );

    if (index !== -1 && index !== null) {
      updatedBeneficiado = {
        ...beneficiadosFormateadosSinDuplicidad[index],
        idBeneficiado: beneficiadoOriginal.idBeneficiado
      };
      beneficiadosFormateadosSinDuplicidad[index] = updatedBeneficiado;
      return updatedBeneficiado;
    }

    updatedBeneficiado = {
      ...beneficiadoOriginal,
      estatus: 0
    };

    // console.log('Entra: ', beneficiadoOriginal.idContabilidad);

    beneficiadosFormateadosSinDuplicidad.push(updatedBeneficiado);
    return updatedBeneficiado;
  });

  // console.log('beneficiadosOriginales: ', beneficiadosOriginales);

  // console.log('beneficiadosFormateadosSinDuplicidad 3: ', beneficiadosFormateadosSinDuplicidad);

  return beneficiadosFormateadosSinDuplicidad;
};

const formatServidoresPublicos = (
  servidoresPublicos,
  catalogoServidoresPublicos,
  servidoresPublicosOriginales
) => {
  let servPubTem;
  const servidoresPublicosFormateados = servidoresPublicos?.map((servidor, index) => {
    if (
      servidor.estatus === undefined &&
      servidor.servidorPublicoId !== undefined &&
      servidor.servidorPublicoId !== 0
    ) {
      servPubTem = catalogoServidoresPublicos.find(
        (sp) => sp.idUsuario === servidor.servidorPublicoId
      );

      return {
        ...servPubTem,
        pkFirmante: index + 4,
        idTipoFirmante: 1,
        numConstancia: servidor.numeroConstancia,
        cargoAutoriza: servidor.cargoAutoriza,
        firma:
          servidor.firma.fileList[0]?.status === 'done'
            ? servidor.firma.fileList[0]?.url.split(',')[1]
            : servidor.firma?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
        identAnverso:
          servidor.identAnverso.fileList[0]?.status === 'done'
            ? servidor.identAnverso.fileList[0]?.url.split(',')[1]
            : servidor.identAnverso?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
        identReverso:
          servidor.identReverso.fileList[0]?.status === 'done'
            ? servidor.identReverso.fileList[0]?.url.split(',')[1]
            : servidor.identReverso?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
      };
    }
    return {
      ...servidor,
      pkFirmante: index + 4,
      idTipoFirmante: 1,
      numConstancia: servidor.numeroConstancia,
      firma:
        servidor.firma.fileList[0]?.status === 'done'
          ? servidor.firma.fileList[0]?.url.split(',')[1]
          : servidor.firma?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
      identAnverso:
        servidor.identAnverso.fileList[0]?.status === 'done'
          ? servidor.identAnverso.fileList[0]?.url.split(',')[1]
          : servidor.identAnverso?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
      identReverso:
        servidor.identReverso.fileList[0]?.status === 'done'
          ? servidor.identReverso.fileList[0]?.url.split(',')[1]
          : servidor.identReverso?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
    };
  });

  const servidoresPublicosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
    servidoresPublicosFormateados,
    'nombre',
    'apPaterno',
    'apMaterno',
    'nombreCompleto'
  );

  servidoresPublicosOriginales?.map((servidorOriginal) => {
    let updateServidorPublico = {};

    const index = findByElement(servidoresPublicosSinDuplicidad, 'nombre', servidorOriginal.nombre);

    if (index !== -1 && index !== null) {
      updateServidorPublico = {
        ...servidoresPublicosSinDuplicidad[index],
        idFirmante: servidorOriginal.idFirmante
      };
      servidoresPublicosSinDuplicidad[index] = updateServidorPublico;
      return updateServidorPublico;
    }

    updateServidorPublico = {
      ...servidorOriginal,
      pkFirmante: 4,
      estatus: 0,
      firma: null,
      identAnverso: null,
      identReverso: null
    };
    servidoresPublicosSinDuplicidad.push(updateServidorPublico);
    return updateServidorPublico;
  });
  return servidoresPublicosSinDuplicidad;
};

const formatServidoresPublicosJL = (servidoresPublicosJL, servidoresPublicosOriginalesJL) => {
  const servidoresPublicosJLFormateados = servidoresPublicosJL.map((servidor, index) => {
    if (servidor.estatus === undefined) {
      return {
        pkFirmante: index + 4,
        idTipoFirmante: 2,
        apMaterno: servidor.apMaterno,
        apPaterno: servidor.apPaterno,
        puesto: servidor.puesto,
        nombre: servidor.nombre,
        numJunta: servidor.numeroJuntaLC,
        numEmpleado: servidor.numEmpleado,
        firma:
          servidor.firma.fileList[0]?.status === 'done'
            ? servidor.firma.fileList[0]?.url.split(',')[1]
            : servidor.firma?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
        identAnverso:
          servidor.identAnverso.fileList[0]?.status === 'done'
            ? servidor.identAnverso.fileList[0]?.url.split(',')[1]
            : servidor.identAnverso?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
        identReverso:
          servidor.identReverso.fileList[0]?.status === 'done'
            ? servidor.identReverso.fileList[0]?.url.split(',')[1]
            : servidor.identReverso?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
      };
    }

    return {
      ...servidor,
      pkFirmante: index + 4
    };
  });

  const servidoresPublicosJLSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
    servidoresPublicosJLFormateados,
    'nombre',
    'apPaterno',
    'apMaterno'
  );

  servidoresPublicosOriginalesJL?.map((servidorOriginal) => {
    let updateServidorPublicoJL = {};

    const index = findByElement(
      servidoresPublicosJLSinDuplicidad,
      'nombre',
      servidorOriginal.nombre
    );

    if (index !== -1 && index !== null) {
      updateServidorPublicoJL = {
        ...servidoresPublicosJLSinDuplicidad[index],
        idFirmante: servidorOriginal.idFirmante
      };
      servidoresPublicosJLSinDuplicidad[index] = updateServidorPublicoJL;
      return updateServidorPublicoJL;
    }

    updateServidorPublicoJL = {
      ...servidorOriginal,
      pkFirmante: 4,
      estatus: 0,
      firma: null,
      identAnverso: null,
      identReverso: null
    };

    servidoresPublicosJLSinDuplicidad.push(updateServidorPublicoJL);
    return updateServidorPublicoJL;
  });
  return servidoresPublicosJLSinDuplicidad;
};

const formatRepresentantesSujetosObligados = (representantesSO, representatesOriginalesSO) => {
  const representantesSOFormateados = representantesSO?.map((so, index) => {
    return {
      pkFirmante: index + 4,
      idTipoFirmante: 3,
      apMaterno: so.segundoApellido,
      apPaterno: so.primerApellido,
      claveElector: so.claveElector,
      correoSO: so.correoElectronico,
      idSujetoObligado: so.sujetoObligado ? 0 : so.sujetoObligadoId,
      sujetoObligado: so.sujetoObligado, // Captura manual
      idTipoAsociacion: so.tipoAsociacionId,
      acreditacion: so.acreditacion,
      nombre: so.nombre,
      puesto: so.puesto,
      firma:
        so.firma.fileList[0]?.status === 'done'
          ? so.firma.fileList[0]?.url.split(',')[1]
          : so.firma?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
      identAnverso:
        so.identAnverso.fileList[0]?.status === 'done'
          ? so.identAnverso.fileList[0]?.url.split(',')[1]
          : so.identAnverso?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
      identReverso:
        so.identReverso.fileList[0]?.status === 'done'
          ? so.identReverso.fileList[0]?.url.split(',')[1]
          : so.identReverso?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
    };
  });

  const representantesSOSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
    representantesSOFormateados,
    'nombre',
    'apPaterno',
    'apMaterno'
  );

  representatesOriginalesSO?.map((representante) => {
    let updateRepresentanteSO = {};
    const index = findByElement(representantesSOSinDuplicidad, 'nombre', representante.nombre);

    if (index !== -1 && index !== null) {
      updateRepresentanteSO = {
        ...representantesSOSinDuplicidad[index],
        idFirmante: representante.idFirmante,
        idTipoFirmante: 3
      };
      representantesSOSinDuplicidad[index] = updateRepresentanteSO;
      return updateRepresentanteSO;
    }
    updateRepresentanteSO = {
      ...representante,
      idFirmante: representante.idFirmante,
      pkFirmante: 4,
      estatus: 0,
      firma: null,
      identAnverso: null,
      identReverso: null
    };
    representantesSOSinDuplicidad.push(updateRepresentanteSO);
    return updateRepresentanteSO;
  });

  return representantesSOSinDuplicidad;
};

export const formatCreateNewActaInicio = (dataFormulario, catalogos) => {
  // Esta estructura es solicitada por backend
  const payloadBase = {
    monitoreos: {
      toTerminate: [],
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toSave: []
    },
    actasInicio: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    },
    hallazgos: {
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toUpdate: [],
      toSave: []
    },
    actasCierre: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    }
  };

  const nuevoMonitoreo = {
    pkMonitoreo: 1, // Este valor se queda fijo puede ser lo que sea
    idTipoMonitoreo: MONITOREOS_ESPECTACULARES,
    estatusMonitoreo: MONITOREO_EN_PROCESO.value,
    idProcesoGral: dataFormulario.idProcesoGral,
    descripcionProcesoGral:
      catalogos.data.procesosElectorales?.find(
        (p) => p.idProcesoElectoral === dataFormulario.idProcesoGral
      )?.descripcion || '',
    // descripcionProcesoGral: '', // TODO: ver si es necesario para la edicion
    idTipoEleccion: 1, // No se establece desde el formulario
    idAmbito: catalogos.data.procesosElectorales?.find(
      (p) => p.idProcesoElectoral === dataFormulario.idProcesoGral
    )?.idAmbito,
    idEstado: dataFormulario.estadoId,
    tipoRegistro: TIPO_ACCESO_WEB,
    idUsuario: 200, // TODO: ver si es necesario
    fechaRegistro: dayjs().format(FORMAT_BACKEND), // Momento de la generacion
    // notificarPartido: 0, // No se establece en la tabla
    actas: [
      {
        pkActa: 2, // Dato arbitrario solicitado por el payload
        fechaApertura: dayjs(dataFormulario.horaInicial).format(FORMAT_BACKEND),
        fechaCierre: dayjs(dataFormulario.horaFinal).format(FORMAT_BACKEND),
        idTipoActa: INICIO,
        tipoRegistro: TIPO_ACCESO_WEB,
        idProcesoEspecifico: dataFormulario.procesoEspecificoId,
        estatus: 4,
        otrosHechos: dataFormulario.hechos,
        recorrido: dataFormulario.recorrido,
        usoVoz: dataFormulario.usoVoz,
        ubicacion: {
          pkUbicacion: 12,
          numJunta: dataFormulario.distritoFedId,
          idMunicipio: dataFormulario.municipioId,
          calle: dataFormulario.calle,
          numero: dataFormulario.numeroExterior,
          colonia: dataFormulario.colonia,
          codigoPostal: dataFormulario.codigoPostal,
          entreCalle1: dataFormulario.calle1,
          entreCalle2: dataFormulario.calle2,
          referencias: dataFormulario.referencias,
          latitud: '9.361880376536499',
          longitud: '-75.94551341846224'
        },
        fiscalizacion: formatServidoresPublicos(
          dataFormulario.fiscalizacion,
          catalogos.data.usuariosFiscalizacion
        ),
        juntaLocalDistrital: formatServidoresPublicosJL(dataFormulario.juntaLocalDistrital),
        sujetosObligados: formatRepresentantesSujetosObligados(dataFormulario.sujetosObligados)
      }
    ]
  };

  payloadBase.monitoreos.toSave.push(nuevoMonitoreo);
  return payloadBase;
};

export const formatCreateNewActaCierre = (dataFormulario, catalogos, monitoreoId) => {
  // Esta estructura es solicitada por backend
  const payloadBase = {
    monitoreos: {
      toTerminate: [],
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toSave: []
    },
    actasInicio: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    },
    hallazgos: {
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toUpdate: [],
      toSave: []
    },
    actasCierre: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    }
  };

  const nuevaActaCierre = {
    pkActa: 1,
    fechaApertura: dayjs(dataFormulario.horaInicial).format(FORMAT_BACKEND),
    fechaCierre: dayjs(dataFormulario.horaFinal).format(FORMAT_BACKEND),
    idMonitoreo: monitoreoId,
    idTipoActa: CIERRE,
    tipoRegistro: TIPO_ACCESO_WEB,
    idProcesoEspecifico: dataFormulario.procesoEspecificoId,
    estatus: 4,
    otrosHechos: dataFormulario.hechos,
    recorrido: dataFormulario.recorrido,
    usoVoz: dataFormulario.usoVoz,
    ubicacion: {
      pkUbicacion: 12,
      numJunta: dataFormulario.distritoFedId,
      idMunicipio: dataFormulario.municipioId,
      calle: dataFormulario.calle,
      numero: dataFormulario.numeroExterior,
      colonia: dataFormulario.colonia,
      codigoPostal: dataFormulario.codigoPostal,
      entreCalle1: dataFormulario.calle1,
      entreCalle2: dataFormulario.calle2,
      referencias: dataFormulario.referencias,
      latitud: '9.361880376536499',
      longitud: '-75.94551341846224'
    },
    fiscalizacion: formatServidoresPublicos(
      dataFormulario.fiscalizacion,
      catalogos.data.usuariosFiscalizacion
    ),
    juntaLocalDistrital: formatServidoresPublicosJL(dataFormulario.juntaLocalDistrital),
    sujetosObligados: formatRepresentantesSujetosObligados(dataFormulario.sujetosObligados)
  };

  payloadBase.actasCierre.toSave.push(nuevaActaCierre);
  return payloadBase;
};

export const formatEditActaInicio = (dataFormulario, catalogos, initialData) => {
  // Esta estructura es solicitada por backend
  const payloadBase = {
    monitoreos: {
      toTerminate: [],
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toSave: []
    },
    actasInicio: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    },
    hallazgos: {
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toUpdate: [],
      toSave: []
    },
    actasCierre: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    }
  };

  const initialDataFiscalizacion = initialData?.tableRow?.actas[0]?.fiscalizacion || [];
  const initialDataJuntaLocalDistrital = initialData?.tableRow?.actas[0].juntaLocalDistrital || [];
  const initialDatasujetoObligados = initialData?.tableRow?.actas[0].sujetosObligados || [];

  const editarActaInicio = {
    pkActa: 2,
    pkMonitoreo: 1,
    idMonitoreo: initialData?.tableRow?.actas[0]?.idMonitoreo,
    idActa: initialData?.tableRow?.actas[0]?.idActa,
    idProcesoGral: dataFormulario.idProcesoGral,
    fechaApertura: dayjs(dataFormulario.horaInicial).format(FORMAT_BACKEND),
    idProcesoEspecifico: dataFormulario.procesoEspecificoId,
    estatus: dataFormulario.estatus,
    descripcionProcesoGral:
      catalogos.data.procesosElectorales?.find(
        (p) => p.idProcesoElectoral === dataFormulario.idProcesoGral
      )?.descripcion || '',
    // descripcionProcesoGral: '', // TODO: ver si es necesario para la edicion
    idAmbito: catalogos.data.procesosElectorales?.find(
      (p) => p.idProcesoElectoral === dataFormulario.idProcesoGral
    )?.idAmbito,
    idEstado: dataFormulario.estadoId,
    otrosHechos: dataFormulario.hechos,
    recorrido: dataFormulario.recorrido,
    usoVoz: dataFormulario.usoVoz,
    ubicacion: {
      idUbicacion: initialData?.tableRow?.actas[0]?.ubicacion.idUbicacion,
      numJunta: dataFormulario.distritoFedId,
      idMunicipio: dataFormulario.municipioId,
      calle: dataFormulario.calle,
      numero: dataFormulario.numeroExterior,
      colonia: dataFormulario.colonia,
      codigoPostal: dataFormulario.codigoPostal,
      entreCalle1: dataFormulario.calle1,
      entreCalle2: dataFormulario.calle2,
      referencias: dataFormulario.referencias
    },
    fiscalizacion: formatServidoresPublicos(
      dataFormulario.fiscalizacion,
      catalogos.data.usuariosFiscalizacion,
      initialDataFiscalizacion
    ),
    juntaLocalDistrital: formatServidoresPublicosJL(
      dataFormulario.juntaLocalDistrital,
      initialDataJuntaLocalDistrital
    ),
    sujetosObligados: formatRepresentantesSujetosObligados(
      dataFormulario.sujetosObligados,
      initialDatasujetoObligados
    )
  };

  // Verifica si se cambió el estatus. Si es cancelado se envía a cancelar el hallazgo
  if (
    dataFormulario.estatus !== initialData?.tableRow?.actas[0].estatus &&
    dataFormulario.estatus === 3
  ) {
    payloadBase.actasInicio.toCancel = [
      {
        pkActa: initialData?.tableRow?.actas[0]?.idActa,
        idActa: initialData?.tableRow?.actas[0]?.idActa,
        idMonitoreo: initialData?.tableRow?.actas[0]?.idMonitoreo,
        motivoCancelacion: dataFormulario?.motivoCancelacion
      }
    ];
  }

  payloadBase.actasInicio.toUpdate.push(editarActaInicio);
  return payloadBase;
};

export const formatEditActaCierre = (dataFormulario, catalogos, initialData) => {
  // Esta estructura es solicitada por backend
  const payloadBase = {
    monitoreos: {
      toTerminate: [],
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toSave: []
    },
    actasInicio: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    },
    hallazgos: {
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toUpdate: [],
      toSave: []
    },
    actasCierre: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    }
  };

  const initialDataFiscalizacion = initialData?.tableRow?.actas[0]?.fiscalizacion || [];
  const initialDataJuntaLocalDistrital = initialData?.tableRow?.actas[0].juntaLocalDistrital || [];
  const initialDatasujetoObligados = initialData?.tableRow?.actas[0].sujetosObligados || [];

  const editarActaCierre = {
    pkActa: initialData?.tableRow?.actas[0]?.idActa,
    pkMonitoreo: initialData?.tableRow?.actas[0]?.idMonitoreo,
    idMonitoreo: initialData?.tableRow?.actas[0]?.idMonitoreo,
    idActa: initialData?.tableRow?.actas[0]?.idActa,
    estatus: dataFormulario.estatus,
    otrosHechos: dataFormulario.hechos,
    recorrido: dataFormulario.recorrido,
    usoVoz: dataFormulario.usoVoz,
    idEstado: dataFormulario.estadoId,
    ubicacion: {
      idUbicacion: initialData?.tableRow?.actas[0]?.ubicacion.idUbicacion,
      numJunta: dataFormulario.distritoFedId,
      idMunicipio: dataFormulario.municipioId,
      calle: dataFormulario.calle,
      numero: dataFormulario.numeroExterior,
      colonia: dataFormulario.colonia,
      codigoPostal: dataFormulario.codigoPostal,
      entreCalle1: dataFormulario.calle1,
      entreCalle2: dataFormulario.calle2,
      referencias: dataFormulario.referencias
    },
    fiscalizacion: formatServidoresPublicos(
      dataFormulario.fiscalizacion,
      catalogos.data.usuariosFiscalizacion,
      initialDataFiscalizacion
    ),
    juntaLocalDistrital: formatServidoresPublicosJL(
      dataFormulario.juntaLocalDistrital,
      initialDataJuntaLocalDistrital
    ),
    sujetosObligados: formatRepresentantesSujetosObligados(
      dataFormulario.sujetosObligados,
      initialDatasujetoObligados
    )
  };

  // Verifica si se cambió el estatus. Si es cancelado se envía a cancelar el hallazgo
  if (
    dataFormulario.estatus !== initialData?.tableRow?.actas[0].estatus &&
    dataFormulario.estatus === 3
  ) {
    payloadBase.actasCierre.toCancel = [
      {
        pkActa: initialData?.tableRow?.actas[0]?.idActa,
        idActa: initialData?.tableRow?.actas[0]?.idActa,
        idMonitoreo: initialData?.tableRow?.actas[0]?.idMonitoreo,
        motivoCancelacion: dataFormulario?.motivoCancelacion
      }
    ];
  }

  payloadBase.actasCierre.toUpdate.push(editarActaCierre);
  return payloadBase;
};

export const formatFromBackToFormActaInicio = (monitoreo) => {
  const dataActaInicio = monitoreo?.actas.find((acta) => acta.idTipoActa === INICIO);
  const fechaInicial = dayjs(dataActaInicio.fechaApertura, 'YYYYMMDDHHmmss');
  const fechaFinal = dayjs(dataActaInicio.fechaCierre, 'YYYYMMDDHHmmss');
  return {
    idProcesoGral: monitoreo.idProcesoGral,
    folioMonitoreo: dataActaInicio.folioMonitoreo,
    estatus: monitoreo.actas?.[0]?.estatus,
    motivoCancelacion: monitoreo.actas?.[0]?.motivoCancelacion,
    estatusMonitoreo: monitoreo.estatusMonitoreo,
    estatusMonitoreoId: monitoreo.estatusMonitoreoId,
    procesoEspecificoId: dataActaInicio.idProcesoEspecifico,
    horaInicial: fechaInicial,
    horaFinal: fechaFinal,
    estadoId: monitoreo.idEstado,
    distritoFedId: dataActaInicio.ubicacion.numJunta,
    municipioId: dataActaInicio.ubicacion.idMunicipio,
    calle: dataActaInicio.ubicacion.calle,
    numeroExterior: dataActaInicio.ubicacion.numero,
    colonia: dataActaInicio.ubicacion.colonia,
    codigoPostal: dataActaInicio.ubicacion.codigoPostal,
    calle1: dataActaInicio.ubicacion.entreCalle1,
    calle2: dataActaInicio.ubicacion.entreCalle2,
    referencias: dataActaInicio.ubicacion.referencias,
    fiscalizacion: dataActaInicio.fiscalizacion.map((sp) => ({
      servidorPublicoId: sp.idUsuario,
      numEmpleado: sp.numEmpleado,
      nombre: sp.nombre,
      apPaterno: sp.apPaterno,
      apMaterno: sp.apMaterno,
      puesto: sp.puesto,
      cargoAutoriza: sp.cargoAutoriza,
      numeroConstancia: sp.numConstancia,
      identAnverso: sp.identAnverso,
      identReverso: sp.identReverso,
      firma: sp.firma
    })),
    juntaLocalDistrital: dataActaInicio.juntaLocalDistrital.map((sp) => ({
      apPaterno: sp.apPaterno,
      apMaterno: sp.apMaterno,
      nombre: sp.nombre,
      puesto: sp.puesto,
      numeroJuntaLC: sp.numJunta,
      numEmpleado: sp.numEmpleado,
      identAnverso: sp.identAnverso,
      identReverso: sp.identReverso,
      firma: sp.firma
    })),
    recorrido: dataActaInicio.recorrido,
    sujetosObligados: dataActaInicio.sujetosObligados.map((so) => ({
      tipoAsociacionId: so.idTipoAsociacion,
      sujetoObligadoId: so.idSujetoObligado,
      sujetoObligado: so.sujetoObligado,
      acreditacion: so.acreditacion,
      primerApellido: so.apPaterno,
      segundoApellido: so.apMaterno,
      nombre: so.nombre,
      puesto: so.puesto,
      claveElector: so.claveElector,
      correoElectronico: so.correoSO,
      firma: so.firma,
      identAnverso: so.identAnverso,
      identReverso: so.identReverso
    })),
    usoVoz: dataActaInicio.usoVoz,
    hechos: dataActaInicio.otrosHechos
  };
};

export const formatFromBackToFormActaCierre = (monitoreo) => {
  const dataActaCierre = monitoreo?.actas.find((acta) => acta.idTipoActa === CIERRE);
  const fechaInicial = dayjs(dataActaCierre.fechaApertura, 'YYYYMMDDHHmmss');
  const fechaFinal = dayjs(dataActaCierre.fechaCierre, 'YYYYMMDDHHmmss');
  return {
    idProcesoGral: monitoreo.idProcesoGral,
    folioMonitoreo: dataActaCierre.folioMonitoreo,
    estatus: monitoreo.actas?.[0]?.estatus,
    motivoCancelacion: monitoreo.actas?.[0]?.motivoCancelacion,
    estatusMonitoreo: monitoreo.estatusMonitoreo,
    estatusMonitoreoId: monitoreo.estatusMonitoreoId,
    procesoEspecificoId: dataActaCierre.idProcesoEspecifico,
    horaInicial: fechaInicial,
    horaFinal: fechaFinal,
    estadoId: monitoreo.idEstado,
    distritoFedId: dataActaCierre.ubicacion.numJunta,
    municipioId: dataActaCierre.ubicacion.idMunicipio,
    calle: dataActaCierre.ubicacion.calle,
    numeroExterior: dataActaCierre.ubicacion.numero,
    colonia: dataActaCierre.ubicacion.colonia,
    codigoPostal: dataActaCierre.ubicacion.codigoPostal,
    calle1: dataActaCierre.ubicacion.entreCalle1,
    calle2: dataActaCierre.ubicacion.entreCalle2,
    referencias: dataActaCierre.ubicacion.referencias,
    fiscalizacion: dataActaCierre.fiscalizacion.map((sp) => ({
      servidorPublicoId: sp.idUsuario,
      numEmpleado: sp.numEmpleado,
      nombre: sp.nombre,
      apPaterno: sp.apPaterno,
      apMaterno: sp.apMaterno,
      puesto: sp.puesto,
      cargoAutoriza: sp.cargoAutoriza,
      numeroConstancia: sp.numConstancia,
      identAnverso: sp.identAnverso,
      identReverso: sp.identReverso,
      firma: sp.firma
    })),
    juntaLocalDistrital: dataActaCierre.juntaLocalDistrital.map((sp) => ({
      apPaterno: sp.apPaterno,
      apMaterno: sp.apMaterno,
      nombre: sp.nombre,
      puesto: sp.puesto,
      numeroJuntaLC: sp.numJunta,
      numEmpleado: sp.numEmpleado,
      identAnverso: sp.identAnverso,
      identReverso: sp.identReverso,
      firma: sp.firma
    })),
    recorrido: dataActaCierre.recorrido,
    sujetosObligados: dataActaCierre.sujetosObligados.map((so) => ({
      tipoAsociacionId: so.idTipoAsociacion,
      sujetoObligadoId: so.idSujetoObligado,
      sujetoObligado: so.sujetoObligado,
      acreditacion: so.acreditacion,
      primerApellido: so.apPaterno,
      segundoApellido: so.apMaterno,
      nombre: so.nombre,
      puesto: so.puesto,
      claveElector: so.claveElector,
      correoElectronico: so.correoSO,
      firma: so.firma,
      identAnverso: so.identAnverso,
      identReverso: so.identReverso
    })),
    usoVoz: dataActaCierre.usoVoz,
    hechos: dataActaCierre.otrosHechos
  };
};

export const formatFromBackToFormNewActaCierre = (monitoreo) => {
  const dataActaCierre = monitoreo?.actas.find((acta) => acta.idTipoActa === INICIO);
  const fechaInicial = dayjs(dataActaCierre.fechaApertura, 'YYYYMMDDHHmmss');
  const fechaFinal = dayjs(dataActaCierre.fechaCierre, 'YYYYMMDDHHmmss');

  return {
    idProcesoGral: monitoreo.idProcesoGral,
    folioMonitoreo: monitoreo.folio,
    procesoEspecificoId: dataActaCierre.idProcesoEspecifico,
    horaInicial: fechaInicial,
    horaFinal: fechaFinal,
    estadoId: monitoreo.idEstado,
    distritoFedId: dataActaCierre?.ubicacion?.numJunta,
    municipioId: dataActaCierre?.ubicacion?.idMunicipio,
    calle: dataActaCierre?.ubicacion?.calle,
    numeroExterior: dataActaCierre?.ubicacion?.numero,
    colonia: dataActaCierre?.ubicacion?.colonia,
    codigoPostal: dataActaCierre?.ubicacion?.codigoPostal,
    calle1: dataActaCierre?.ubicacion?.entreCalle1,
    calle2: dataActaCierre?.ubicacion?.entreCalle2,
    referencias: dataActaCierre?.ubicacion?.referencias,
    fiscalizacion: dataActaCierre?.fiscalizacion.map((sp) => ({
      servidorPublicoId: sp.idUsuario === null ? 0 : sp.idUsuario,
      cargoAutoriza: sp.cargoAutoriza,
      numeroConstancia: sp.numConstancia,
      numEmpleado: sp.numEmpleado,
      nombre: sp.nombre,
      apPaterno: sp.apPaterno,
      apMaterno: sp.apMaterno,
      puesto: sp.puesto,
      firma: {
        fileList: [
          {
            uid: 1,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(sp.firma),
            thumbUrl: generateImageUri(sp.firma)
          }
        ]
      },
      identAnverso: {
        fileList: [
          {
            uid: 2,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(sp.identAnverso),
            thumbUrl: generateImageUri(sp.identAnverso)
          }
        ]
      },
      identReverso: {
        fileList: [
          {
            uid: 3,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(sp.identReverso),
            thumbUrl: generateImageUri(sp.identReverso)
          }
        ]
      }
    })),
    juntaLocalDistrital: dataActaCierre.juntaLocalDistrital.map((sp) => ({
      apPaterno: sp.apPaterno,
      apMaterno: sp.apMaterno,
      nombre: sp.nombre,
      puesto: sp.puesto,
      numeroJuntaLC: sp.numJunta,
      numEmpleado: sp.numEmpleado,
      firma: {
        fileList: [
          {
            uid: 1,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(sp.firma),
            thumbUrl: generateImageUri(sp.firma)
          }
        ]
      },
      identAnverso: {
        fileList: [
          {
            uid: 2,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(sp.identAnverso),
            thumbUrl: generateImageUri(sp.identAnverso)
          }
        ]
      },
      identReverso: {
        fileList: [
          {
            uid: 3,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(sp.identReverso),
            thumbUrl: generateImageUri(sp.identReverso)
          }
        ]
      }
    })),
    recorrido: dataActaCierre.recorrido,
    sujetosObligados: dataActaCierre.sujetosObligados.map((so) => ({
      tipoAsociacionId: so.idTipoAsociacion,
      sujetoObligadoId: so.idSujetoObligado,
      sujetoObligado: so.sujetoObligado,
      acreditacion: so.acreditacion,
      primerApellido: so.apPaterno,
      segundoApellido: so.apMaterno,
      nombre: so.nombre,
      puesto: so.puesto,
      claveElector: so.claveElector,
      correoElectronico: so.correoSO,
      firma: {
        fileList: [
          {
            uid: 1,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(so.firma),
            thumbUrl: generateImageUri(so.firma)
          }
        ]
      },
      identAnverso: {
        fileList: [
          {
            uid: 2,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(so.identAnverso),
            thumbUrl: generateImageUri(so.identAnverso)
          }
        ]
      },
      identReverso: {
        fileList: [
          {
            uid: 3,
            status: 'done',
            name: 'imgFirma.png',
            url: generateImageUri(so.identReverso),
            thumbUrl: generateImageUri(so.identReverso)
          }
        ]
      }
    })),
    usoVoz: dataActaCierre.usoVoz,
    hechos: dataActaCierre.otrosHechos
  };
};
